<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sd/deliveryBillDetails/unHandle"
        :table-select="true"
        @addOrEdit="addEditHandle"
        @reset="resetHandle"
        @delete="deleteHandle"
        @select="selectHandle">
      <template slot="otherBtn">
        <el-button v-if="limits.printAuth" type="primary" :disabled="!selection.length" @click="printLabel">
          打印
        </el-button>
        <el-button v-if="limits.printAuth" type="primary" :disabled="selection.length !== 1" @click="printLabel1">
          打印标签
        </el-button>
        <el-button v-if="closeAuth" type="primary" :disabled="selection.length !== 1" @click="closeDelivery">
          关闭
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="ERP销售单号">
            <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="ERP发货单号">
            <el-input v-model.trim="filter.erpBillNo" placeholder="请输入" clearable/>
          </el-form-item>
          <!--          <el-form-item label="物料类型">-->
          <!--            <el-select v-model="filter.materialTypeId" placeholder="请选择" clearable>-->
          <!--              <el-option-->
          <!--                  v-for="item in materialTypeList"-->
          <!--                  :key="item.pkid"-->
          <!--                  :label="item.materialTypeName"-->
          <!--                  :value="item.pkid"/>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item label="物料类型">
            <el-select
                v-model="materialTypeList"
                :popper-append-to-body="false"
                class="biddingStageSty"
                multiple
                clearable
                placeholder="请选择"
                @change="handleSelect">
              <el-option v-for="item in materialTypeOptions" :key="item.value" :label="item.name" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="发货地址">
            <el-input v-model.trim="filter.deliveryAddress" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="打印次数">
            <el-select v-model="filter.printTimes" placeholder="请选择" clearable>
              <el-option label="0" :value="0"/>
              <el-option label="1" :value="1"/>
              <el-option label="2" :value="2"/>
              <el-option label="3" :value="3"/>
              <el-option label="4" :value="4"/>
              <el-option label="5" :value="5"/>
              <el-option label="6" :value="6"/>
              <el-option label="7" :value="7"/>
              <el-option label="8" :value="8"/>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model.trim="filter.note" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户编号">
            <el-input v-model.trim="filter.customerNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="最终客户">
            <el-input v-model.trim="filter.finalCustomerName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="要求交期">
            <el-date-picker
                v-model="deliveryDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('deliveryDateRange', 'deliveryBeginDate', 'deliveryEndDate')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <!--        <el-button type="primary" :disabled="scope.row.status !== 0" @click="submitRow(scope.row)"> 提交</el-button>-->
        <el-button type="primary" @click="updateDate(scope.row)">维护交期</el-button>
      </template>
    </view-table>
    <edit-page ref="editPage" @save-success="loadData(1)"/>
    <delivery-notice-detail-print ref="deliveryPrint" @save-success="loadData(1)"/>
    <delivery-notice-label ref="deliveryNoticeLabel"/>
    <notice-final-delivery ref="noticeFinalDelivery"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import EditPage from "@/views/SalesManage/DeliveryNotice/DeliveryNoticeEdit.vue";
  import DeliveryNoticeLabel from "@/views/StoreManagement/OutStockDelivery/DeliveryNoticeLabel";
  import NoticeFinalDelivery from "@/views/StoreManagement/UnHandleDelivery/NoticeFinalDelivery";
  import DeliveryNoticeDetailPrint from "@/views/SalesManage/DeliveryNotice/DeliveryNoticeDetailPrint";

  export default {
    name: "DeliveryNoticeDetailUnHandleList",
    components: {ViewTable, EditPage, DeliveryNoticeLabel, NoticeFinalDelivery, DeliveryNoticeDetailPrint},
    data() {
      return {
        limits: {
          printAuth: this.$auth(483),
        },
        closeAuth: this.$auth(295),
        selection: [],
        ids: [],
        pkids: [],
        deliveryDateRange: [],
        materialTypeList: [],
        materialTypeOptions: [],
        filter: {
          billNo: "",
          customerNo: "",
          customerName: "",
          deliveryBeginDate: "",
          deliveryEndDate: "",
          materialNo: "",
          materialName: "",
          salesOrderNo: "",
          specification: "",
          erpBillNo: "",
          note: "",
          creatorName: "",
          isDelivery: 10,
          materialTypeId: "",
          materialTypeIds: "",
          finalCustomerName: "",
          deliveryAddress: "",
          printTimes: "",
        },
        columnsProperty: [
          {
            key: "billNo",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.editPage.open(params.row.masterId, true);
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            key: "action",
            align: "center",
            fixed: "right",
            width: 100,
            slot: "action",
          },
        ],
      };
    },
    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.materialTypeIds": {
        handler(val) {
          if (val) {
            this.materialTypeList = [];
            this.materialTypeOptions.map(item => {
              val.split(",").forEach((s) => {
                if (parseInt(s) === parseInt(item.value)) {
                  this.materialTypeList.push(item.value);
                }
              });
            });
          }
        },
      },
    },
    created() {
      this.getMaterialTypeList();
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      getMaterialTypeList() {
        this.materialTypeOptions = [];
        this.$http.get("basic", "materialTypes/getAllList").then((res) => {
          if (res.success) {
            res.data.forEach((item) => {
              let temp = {"name": item.materialTypeName, "value": item.pkid};
              this.materialTypeOptions.push(temp);
            });
          }
        });
      },
      handleSelect(value) {
        if (value.length) {
          // this.materialTypeList = value;
          this.filter.materialTypeIds = value.join(",");
        } else {
          // this.materialTypeList = [];
          this.filter.materialTypeIds = "";
        }
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      addEditHandle(row) {
        if (row) {
          this.$refs.editPage.open(row.masterId);
        } else {
          this.$refs.editPage.open();
        }
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "sd/DeliveryBills", row.masterId).then(res => {
          if (res.success) {
            this.$message.success("删除成功");
            this.loadData(1);
          }
        });
      },

      selectHandle(selection) {
        this.ids = [];
        this.pkids = [];
        this.selection = selection;
        this.selection.forEach((item) => {
          this.ids.push(item.masterId);
          this.pkids.push(item.pkid);
        });
      },
      updateDate(row) {
        this.$refs.noticeFinalDelivery.open(row);
        this.loadData(1);
      },
      printLabel() {
        this.$refs.deliveryPrint.open(this.pkids);
      },
      closeDelivery() {
        this.$confirm("确定关闭吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "sd/DeliveryBills/batchClose", this.ids).then(res => {
            if (res.success) {
              this.$message.success("关闭成功");
              this.loadData(1);
              this.selection = [];
            }});
        });
      },
      printLabel1() {
        const labelData = {
          customerNo: this.selection[0].customerOuterNo,
          billNo: "",
          orderNo:"",
          materialName: this.selection[0].materialName,
          quantity: this.selection[0].quantity,
          specification: this.selection[0].specification,
          amount: "",
          note: this.selection[0].orderRowNote,
          date: this.$moment().format("yyyy-MM-DD"),
          manufactor: "上海鸿康电器有限公司",
          telephone: "021-37701209",
        };
        this.$refs.deliveryNoticeLabel.open(labelData);
      },
      submitRow(row) {
        this.$http.get("basic", `sd/DeliveryBills/submit/${row.masterId}`).then(res => {
          if (res.success) {
            this.$message.success("提交成功");
            this.loadData(1);
          }
        });
      },

      otherAuth(row) {
        if (row.status === 20 || row.status === 30 || row.status === 40 || row.status === 100) {
          return {
            editAuth: true,
            delAuth: true,
          };
        } else if (row.status == 10) {
          return {
            editAuth: false,
            delAuth: true,
          };
        } else {
          return {
            editAuth: false,
            delAuth: false,
          };
        }
      },
    },

  };
</script>

<style>

</style>